import { render, staticRenderFns } from "./QuestionsReferidos.vue?vue&type=template&id=dac066e2&scoped=true&"
import script from "./QuestionsReferidos.vue?vue&type=script&lang=ts&"
export * from "./QuestionsReferidos.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionsReferidos.vue?vue&type=style&index=0&id=dac066e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac066e2",
  null
  
)

export default component.exports